import React from 'react';

const Footer = () => {
    return(
        <footer className="pv5 ph4 ph5-m ph6-l mid-gray">
            <code className="f4 tc black">Designed & Built by Utkarsh Patadia</code>
            <div className="tc mt3">
                <a href="https://github.com/iamutkarsh23" title="GitHub" className="f5 dib pa2 link bg-animate hover-bg-green underline-hover black">Github</a>
                <a href="https://www.linkedin.com/in/utkarsh-patadia-a291a7171/"    title="LinkedIn" className="f5 dib pa2 link bg-animate hover-bg-blue underline-hover black">LinkedIn</a>
            </div>
        </footer>
    )
}

export default Footer;